export const calculateStrength = (password: string) => {
  let score = 0;

  if (password.length >= 8) {
    score += 20;
  }
  if (password.length >= 12) {
    score += 20;
  }
  if (/[A-Z]/.test(password)) {
    score += 15;
  }
  if (/[a-z]/.test(password)) {
    score += 15;
  }
  if (/\d/.test(password)) {
    score += 15;
  }
  if (/[^A-Za-z0-9]/.test(password)) {
    score += 15;
  }

  return Math.min(score, 100);
};
